import { useLog } from "./core/useLog.js";
export function useCoreLog(subSpace) {
  return useLog(subSpace ? `sfc.${subSpace}` : "sfc");
}
